import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Clickable from "@insite/mobius/Clickable";
import DataTable, { SortOrderOptions } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyProps } from "@insite/mobius/Typography/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import loadCreditData from "@tSurya/Handlers/CreditMemoData";
import { CreditMemo } from "@tSurya/Services/CreditMemoService";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import MyAccountThemeWrapper from "@tSurya/Utils/MyAccountThemeWrapper";
import qs from "qs";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        userData: state.SURData.creditDataStore,
        parameterStore: state.SURData.creditDataStore,
        locationValue: getLocation(state),
        isLoading: state.SURData.creditDataStore.isLoading,
    };
};

const mapDispatchToProps = {
    loadCreditData,
};

export interface SurCreditMemosStyle {
    container?: InjectableCss;
    button?: InjectableCss;
    textField?: InjectableCss;
    dateField?: InjectableCss;
    tableBody?: InjectableCss;
    tableHeader?: InjectableCss;
    tableContainer?: InjectableCss;
    link?: InjectableCss;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    creditAmountHeader?: DataTableHeaderProps;
    creditAmountCell?: DataTableCellProps;
}

export const surSurCreditMemos: SurCreditMemosStyle = {
    creditAmountHeader: {
        css: css`
            text-align: center !important;
            >button{
                justify-content: center !important;
            }
        `,
    },
    creditAmountCell: {
        css: css`
            text-align: right !important;
           

        `,
    },
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        `,
    },
    button: {
        css: css`
            padding-top: 23px;
            button[class^="ButtonWrapper"] {
                border-radius: 0px;
                background: ${getColor("common.background")};
                border: 2px solid ${COLORS.text.main};
                color: ${getColor("text.main")};
            }
        `,
    },

    dateField: {
        css: css`
            div[class^="FormFieldStyle"] {
                label {
                    font-family: "Mulish";
                    font-style: normal;
                    font-weight: ${TYPOGRAPHY.weight.bold};
                    font-size: ${TYPOGRAPHY.size.smaller};
                    line-height: ${TYPOGRAPHY.lineHeight.base};
                    color: ${getColor("text.main")};
                }
            }
        `,
    },
    textField: {
        css: css`
            div[class^="FormFieldStyle"] {
                label {
                    font-family: "Mulish";
                    font-style: normal;
                    font-weight: ${TYPOGRAPHY.weight.bold};
                    font-size: ${TYPOGRAPHY.size.smaller};
                    line-height: ${TYPOGRAPHY.lineHeight.base};
                    color: ${getColor("text.main")};
                }
            }

            div[class^="FormInputWrapper"] {
                input {
                    background: ${getColor("common.background")};
                    border: 1px solid ${getColor("common.border")} !important;
                }
            }
        `,
    },
    tableBody: {
        css: css`
            &:nth-child(even) {
                background: ${getColor("common.background")} !important;
            }
            td {
                font-size: 15px;
                color: ${getColor("text.main")};
            }
            span[class^="TypographyStyle"] {
                color: ${getColor("text.main")};
            }
        `,
    },
    tableHeader: {
        css: css`
            th {
                white-space: nowrap;
                color: ${getColor("text.main")};
            }
            td {
                white-space: nowrap;
                font-size: 15px;
                color: ${getColor("text.main")};
            }
            tr {
                white-space: nowrap;
                color: ${getColor("text.main")};
            }
            button {
                justify-content: center;
            }
            span[class^="TypographyStyle"] {
                color: ${getColor("text.main")};
                text-align: center;
            }
        `,
    },
    tableContainer: {
        css: css`
            margin-top: 20px;
            @media print {
                table {
                    display: table !important;
                }

                tbody {
                    display: table-row-group !important;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        overflow-x: scroll;
                    `,
                    css`
                        overflow-x: scroll;
                    `,
                    css`
                        overflow-x: scroll;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    link: {
        css: css`
            span {
                font-size: 15px;
                color: ${getColor("text.link")} !important;
                &:hover {
                    text-align: center;
                    text-decoration-line: underline;
                }
            }
        `,
    },
    noResultsContainer: {
        css: css`
            text-align: center;
            padding: 20px;
        `,
    },
    noResultsText: {
        size: 16,
        weight: 600,
    },
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
};

const styles = surSurCreditMemos;

export const SurCreditMemos = ({ loadCreditData, userData, parameterStore, locationValue, isLoading }: Props) => {
    const history = useHistory();
    const serachedParameter = parameterStore.searchparameter;
    const creditMemos = userData.creditdata.creditMemos;
    React.useEffect(() => {
        loadCreditData({});
    }, []);

    const [sortfieldData, setsortfieldData] = useState("");
    const [sortedState, setSortedState] = useState<boolean | "asc" | "desc">("asc");

    const headerClick = (sortField: string) => {
        setSortedState(sortedState === "asc" ? "desc" : "asc");
        const sort = sortfieldData === sortField ? `${sortField} DESC` : sortField;
        setsortfieldData(sort);
        loadCreditData({ ...serachedParameter, sort });
    };

    const sorted = (sortField: string) => {
        let sorted: boolean | string = false;
        if (sortfieldData === sortField) {
            sorted = "ascending";
        } else if (sortfieldData === `${sortField} DESC`) {
            sorted = "descending";
        }
        return sorted as SortOrderOptions;
    };

    useEffect(() => {
        const queryString = qs.stringify(serachedParameter);
        if (queryString) {
            history.push(`${locationValue.pathname}?${queryString}`);
        } else {
            history.push(locationValue.pathname);
        }
    }, [serachedParameter]);

    if (isLoading) {
        return (
            <MyAccountThemeWrapper>
                <StyledWrapper {...styles.centeringWrapper}>
                    <LoadingSpinner {...styles.spinner} />
                </StyledWrapper>
            </MyAccountThemeWrapper>
        );
    }

    return (
        <MyAccountThemeWrapper>
            <StyledWrapper>
                {creditMemos?.length ? (
                    <StyledWrapper {...styles.tableContainer}>
                    <DataTable>
                        <DataTableHead {...styles.tableHeader}>
                            <DataTableHeader
                                sorted={sorted("creditMemoNumber")}
                                onSortClick={() => headerClick("creditMemoNumber")}
                            >
                                {translate("Credit Memo")}
                            </DataTableHeader>
                            <DataTableHeader
                                sorted={sorted("creditDate")}
                                onSortClick={() => headerClick("creditDate")}
                            >
                                {translate("Credit Date")}
                            </DataTableHeader>
                            <DataTableHeader sorted={sorted("poNumber")} onSortClick={() => headerClick("poNumber")}>
                                {translate("PO #")}
                            </DataTableHeader>
                            <DataTableHeader
                                sorted={sorted("amount")}
                                onSortClick={() => headerClick("amount")}
                                {...styles.creditAmountHeader}
                            >
                                {translate("Credit Amount")}
                            </DataTableHeader>
                            <DataTableHeader
                                sorted={sorted("applyToInvoiceNo")}
                                onSortClick={() => headerClick("applyToInvoiceNo")}
                            >
                                {translate("Applied to Invoice No.")}
                            </DataTableHeader>
                        </DataTableHead>
                        <DataTableBody>
                            {creditMemos?.map((item: CreditMemo, index: React.Key | undefined) => {
                                return (
                                    <DataTableRow key={Number(index)} {...styles.tableBody}>
                                        <DataTableCell>
                                            <Link
                                                href={`${window.location.origin}/MyAccount/Invoices/Details?creditMemoNumber=${item.creditMemoNumber}`}
                                                {...styles.link}
                                            >
                                                {item.creditMemoNumber}
                                            </Link>
                                        </DataTableCell>

                                        <DataTableCell>
                                            {item.creditDate
                                                ? new Date(item.creditDate).toLocaleDateString("en-US", {
                                                      month: "2-digit",
                                                      day: "2-digit",
                                                      year: "numeric",
                                                  })
                                                : ""}
                                        </DataTableCell>
                                        <DataTableCell>{item.poNumber}</DataTableCell>
                                        <DataTableCell {...styles.creditAmountCell}>
                                            {String(item.amountDisplay).includes("-")
                                                ? `$(${item.amountDisplay.replace("-$", "")})`
                                                : item.amountDisplay}
                                        </DataTableCell>
                                        <DataTableCell>{item.applyToInvoiceNo}</DataTableCell>
                                    </DataTableRow>
                                );
                            })}
                        </DataTableBody>
                    </DataTable>
                </StyledWrapper>
            ) : (
                <StyledWrapper {...styles.noResultsContainer}>
                    <Typography {...styles.noResultsText}>{translate("No Data found")}</Typography>
                </StyledWrapper>
            )}
            </StyledWrapper>
        </MyAccountThemeWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SurCreditMemos),
    definition: {
        group: "Common",
        icon: "Filter",
        displayName: "SurCreditMemos",
        fieldDefinitions: [],
    },
};

export default widgetModule;
